
import { Component, Vue } from 'vue-property-decorator';
import GoogleMapRenderPolygon from '@/components/FieldAndPath/GoogleMapRenderPolygon.vue';
import GoogleMapLoader from '@/components/Map/GoogleMapLoader.vue';
import { GoogleMapConfig } from '@/flightpath-components/types/GoogleMapConfig';
import { awsConfiguration } from '@/aws-configuration';
import { getModule } from 'vuex-module-decorators';
import GlobalStore from '@/store/modules/global';

@Component({
  components: {
    GoogleMapRenderPolygon,
    GoogleMapLoader
  }
})
export default class PolygonMap extends Vue {
  apiKey = awsConfiguration.apiKey;

  globalStore = getModule(GlobalStore, this.$store);

  get mapConfig(): GoogleMapConfig {
    return {
      locationControl: false,
      loaderOptions: { libraries: ['geometry'] },
      mapOptions: {
        zoom: 17,
        center: this.globalStore.defaultMapLocation,
        mapTypeId: 'hybrid',
        mapTypeControl: false,
        zoomControl: false,
        fullscreenControl: false,
        streetViewControl: false,
        clickableIcons: false,
        disableDefaultUI: true
      }
    };
  }
}
